/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {BannerAds} from './BannerAds';

/**
 * The Ads model module.
 * @module model/Ads
 * @version v1
 */
export class Ads {
  /**
   * Constructs a new <code>Ads</code>.
   * @alias module:model/Ads
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Ads</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Ads} obj Optional instance to populate.
   * @return {module:model/Ads} The populated <code>Ads</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Ads();
      if (data.hasOwnProperty('banners'))
        obj.banners = BannerAds.constructFromObject(data['banners']);
      if (data.hasOwnProperty('popups'))
        obj.popups = ApiClient.convertToType(data['popups'], [Object]);
    }
    return obj;
  }
}

/**
 * @member {module:model/BannerAds} banners
 */
Ads.prototype.banners = undefined;

/**
 * @member {Array.<Object>} popups
 */
Ads.prototype.popups = undefined;

